import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Dialog, DialogContent } from "@mui/material";
import { GradientColorHeader } from "@Local/Components/Dialog/";
import {isFunction} from "@Util/utils";
import useOrderApi from "@Apis/useOrderApi";
import OrderInfoSection from '@Local/Orders/Componetnets/OrderInfoSection';
import OrderInvoiceReissuingForm from '@Local/Orders/Componetnets/OrderInvoiceReissuingForm';

// 主彈窗組件
/**
 * 訂單發票重新開立彈窗組件
 *
 * 功能：
 * - 提供發票重新開立的完整彈窗
 * - 整合發票設定表單和操作按鈕
 * - 支援發票重新開立確認流程
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {string} props.className - 自定義樣式類名
 * @param {boolean} props.open - 是否開啟彈窗
 * @param {Object} props.sourceData - 訂單資料
 * @param {Function} props.onClose - 關閉彈窗回調
 * @param {Function} props.refresh - 刷新回調
 * @param {Object} ref - 組件引用
 * @returns {JSX.Element} 發票重新開立對話框
 */
const OrderInvoiceReissuingDialog = React.forwardRef(({ className, open, sourceData: sourceDataProps = {}, onClose, refresh }, ref) => {
    if (!open) return null;

    const {orderID} = sourceDataProps || {};

    const { getOrderReissuingDialogApi } = useOrderApi()

    const [sourceData, setSourceData] = useState({});

    // 取得訂單重開發票資料
    const doGetOrderReissuingApi = async orderID => {
        try {
            let res = await getOrderReissuingDialogApi(orderID);
            if (res) {
                setSourceData(res);
            }
        } catch (error) {
            console.error('取得訂單重開發票資料失敗:', error);
        }
    };

    // 刷新並關閉彈窗
    const handleRefreshFn = () => {
        isFunction(refresh) && refresh();
        isFunction(onClose) && onClose();
    }

    useEffect(() => {
        if (open && orderID) {
            doGetOrderReissuingApi(orderID);
        }
    },
        // eslint-disable-next-line
        [open, orderID]);

    return (
        <Dialog
            className={clsx("order-invoice-reissuing-dialog", "simple-content", "dialog", className)}
            PaperProps={{ className: "wx-65rem" }}
            open={open}
            scroll="paper"
            fullWidth
        >
            <GradientColorHeader onClose={onClose}>重新設定發票</GradientColorHeader>
            <DialogContent className={'bg-default'}>
                <OrderInfoSection className={'mb-2'} invoiceNo={sourceData?.invoiceNo} salesAmount={sourceData?.salesAmount} orderList={sourceData?.orders} />
                <OrderInvoiceReissuingForm
                    orderID={orderID}
                    sourceData={sourceData}
                    refresh={handleRefreshFn}
                />
            </DialogContent>
        </Dialog>
    );
});

export default OrderInvoiceReissuingDialog;
